var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolfSchool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5C11.0145 9.5 9 11.5145 9 14C9 16.4855 11.0145 18.5 13.5 18.5C15.9855 18.5 18 16.4855 18 14C18 11.5145 15.9855 9.5 13.5 9.5ZM13.9642 15.8105C13.4055 16.3925 12.4005 16.3925 11.8425 15.8105L10.3335 14.3015L11.394 13.241L12.9037 14.7507L15.615 12.0395L16.6755 13.1L13.9642 15.8113V15.8105ZM2.25 5H8.25L4.5 8.75H0V7.25C0 6.0095 1.0095 5 2.25 5ZM9.75 4.25V5H8.25V0.5H9.75L12.75 2.375L9.75 4.25ZM12.795 8.045L9.75 5H15.75C16.9905 5 18 6.0095 18 7.25V8.75H16.4025C15.5235 8.2625 14.5328 8 13.5 8C13.2622 8 13.0275 8.018 12.795 8.045ZM9.25725 18.242C8.124 17.1087 7.5 15.602 7.5 14C7.5 12.398 8.12475 10.8905 9.258 9.75725C9.792 9.22325 10.4107 8.807 11.0812 8.5115L9.00075 6.5L5.12175 10.25H0V18.5H9.5415C9.4455 18.4153 9.34875 18.3335 9.25725 18.242ZM4.5 17H2.25V15.5H4.5V17ZM4.5 14H2.25V12.5H4.5V14Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfSchool);
export default __webpack_public_path__ + "static/media/GolfSchool.0faa1fa11ffa5443bd785c7b8a967237.svg";
export { ForwardRef as ReactComponent };